import React from 'react';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Spacer } from 'app/member/layouts/generic';
import { AgentProfileDetails } from './profile';
import { AgentAccountDetails } from '../dashboard/account';
import { AgentEarningsReport } from '../dashboard/report';
import { AgentEarnings } from '../dashboard/earnings';

export const AgentViewPage = () => {
  return (
    <>
      <GridRow num_of_columns={4}>
        <GridColumn>
          <AgentProfileDetails />
          <Spacer multiple={4} />
          <AgentAccountDetails />
        </GridColumn>
        <GridColumn span={3}>
          <AgentEarningsReport />
          <Spacer multiple={4} />
          <AgentEarnings />
        </GridColumn>
      </GridRow>
    </>
  );
};
